<template>
    <div id="main">
        <div class="alert-wrapper">
            <alert-container :messages="msgs" />
        </div>

        <!-- Título -->
        <div class="auditorias">
            <h1 class="title">{{$t('auditorias-acessos')}}</h1>
            <nav class="breadcrumb" aria-label="breadcrumbs">
                <ul>
                    <li><a class="a-inativo">{{$t('colaborador')}}</a></li>
                    <li><a aria-current="page">{{$t('auditorias-acessos')}}</a></li>
                </ul>
            </nav>
        </div>
        
        <div class="page mb-4">

            <div class="columns">
                <div :class="[isMobile ? 'is-top-mobile' : 'pv-6', 'column', 'is-12']">
                    <div class="columns">
                        <div :class="[isMobile ? 'pv-6' : '', 'column', 'is-4']">
                            <vss-select
                                ref="usuarioFilterInput"
                                class="smaller"
                                v-model="usuarioSelected"
                                label="label"
                                title="usuario"
                                placeholder="msg-selecione-um-usuario"
                                :options="usuarioOptions"
                                @search="loadUsuarios"
                                searchable
                                :loading="usuarioLoading"
                                :height="40"
                                noClearfix
                                clearable
                                :invalid="usuarioSelected==null"
                            />
                        </div>
                        <div :class="[isMobile ? 'is-bottom-mobile' : '', 'column', 'is-2']">
                            <verified-date-picker 
                                ref="iniInput"
                                class="datepickerfield"
                                dateType="startDate"
                                title="data-inicial"
                                v-model="periodo.ini"
                                :endDate="periodo.fim"
                                :years-range="[-50, 50]"
                                @input="handleDateChange($event, 'inicio')"
                            />
                        </div>
                        <div :class="[isMobile ? 'is-bottom-mobile' : '', 'column', 'is-2']">
                            <verified-date-picker
                                ref="fimInput"
                                class="datepickerfield"
                                title="data-final"
                                dateType="endDate"
                                v-model="periodo.fim"
                                :startDate="periodo.ini"
                                :years-range="[-50, 50]"
                                @input="handleDateChange($event, 'fim')"
                            />
                        </div>
                        <div :class="[isMobile ? 'pv-6' : '', 'column', 'is-3']">
                            <vss-select
                                ref="acaoFilterInput"
                                class="smaller"
                                v-model="acaoSelected"
                                label="label"
                                title="acao"
                                :options="acaoOptions"
                                :loading="acaoLoading"
                                :height="40"
                                placeholder="selecione-acao"
                                noClearfix
                                clearable
                            />
                        </div>
                        <div :class="[isMobile ? 'pv-6' : '', 'column', 'is-1']" v-if="!isMobile">
                            <b-button 
                                type="is-primary" 
                                icon-right="magnify" 
                                @click="getDados(1)"
                                v-tippy 
                                :title="$t('pesquisar')"
                            />
                        </div>
                    </div>
                </div>
                <div :class="[isMobile ? 'is-bottom-mobile' : 'pv-6', 'column', 'is-narrow', 'is-1']" v-if="isMobile">
                    <div :class="[isMobile ? '' : 'pt-19', 'columns', 'btns-wrapper',  'is-vcentered', 'is-mobile']">
                        <div :class="[isMobile ? 'is-top-mobile' : '', 'ph-6', 'column', 'pv-0', 'is-first', 'is-narrow', 'is-full']">
                            <button class="btn button search" @click="getDados(1)">
                                <b-icon icon="magnify"/>
                                <span>{{ $t('pesquisar') }}</span>
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div class="page results">    
            <!-- Tabela -->
            <div class="table-results" v-show="tableData.length > 0 && !isSearching">
                <b-table 
                    :data="tableData" 
                    :mobile-cards="false" 
                    backend-sorting 
                    hoverable
                >
                        <!-- Dados -->
                        <b-table-column 
                            v-for="(field, index) in tableFields"
                            :key="index"
                            :label="$t(field.label)"
                            :visible="field.visible"
                            :numeric="field.numeric"
                            :sortable="field.sortable"
                            :field="field.key"
                            v-slot="props"
                        >
                            <div v-if="field.key == 'usuario'">
                                <a @click="showAuditoriaDetalheModal(props.row.idloginaudit)">
                                    {{ props.row.usuario ? props.row.usuario.nome : "—" }}
                                </a>
                            </div>
                            <div v-else-if="field.key == 'datahora'">
                                {{ props.row[field.key] | moment("L LT") }}
                            </div>
                            <div v-else class="table-data numeric" >
                                {{ props.row[field.key] }}
                            </div>
                        </b-table-column>
                </b-table>
            </div>

            <div
                v-show="isSearching"
                class="searching-loader"
            >
                <svg class="loading">
                    <use :xlink:href="require('@/assets/img/icons/loader.svg')+'#layer'"></use>
                </svg>
                <div>
                    {{ $t('carregando-dados') }}...
                </div>
            </div>

            <!-- Mensagem 'não há dados' e ajuda de utilização -->
            <div
                v-show="(firstTime || noData) && !isSearching"
                class="searching-loader"
            >
                <svg class="bigicon">
                    <use v-if="firstTime" :xlink:href="require('@/assets/img/icons/magnify.svg')+'#layer'"></use>
                    <use v-else :xlink:href="require('@/assets/img/icons/chart-error.svg')+'#layer'"></use>
                </svg>
                <div v-if="firstTime">
                    {{ $t('descricao-ajuda-filtro-relatorio') }}
                </div>
                <div v-else>
                    {{ $t('no-data') }}
                </div>
            </div>

            <b-modal :active.sync="isShowingAuditoriaDetalhe">
                <AuditoriaAcessoDetalhada :idauditlogin="idAuditoriaDetalhe">
                </AuditoriaAcessoDetalhada>
            </b-modal>

        </div>

        <PaginationViewer
            class="mb-0"
            :resetPagination="pagination.resetPagination"
            :totalItems="pagination.totalRows"
            :perPageOptions="pagination.perPageOptions"
            :optionStarted="pagination.optionStarted"
            @change="updatePagination"
        />

    </div>
</template>

<script>
import ColaboradorService from "@/services/ColaboradorService";
import AuditoriaService from '@/services/AuditoriaService';
import AuditoriaAcessoDetalhada from "@/components/colaborador/AuditoriaAcessoDetalhada"
import Message from "@/models/Message";

export default {
    components: {
        AuditoriaAcessoDetalhada,
    },
    data() {
        return {
            isShowingAuditoriaDetalhe: false,
            idAuditoriaDetalhe: 0,
            service: null,
            periodo: { 
                ini: this.$moment().subtract(1, 'M').toDate(),
                fim: this.$moment().toDate(),
            },
            usuarioOptions: [],
            usuarioSelected: null,
            usuarioLoading: false,
            acaoOptions: [{ label: 'LOGIN_FALHA', id: 0 }, { label: 'LOGIN_SUCESSO', id: 1 }, { label: 'LOGOUT', id: 2 }],
            acaoSelected: null,
            acaoLoading: false,
            tableData: [],
            tableKey: 0,
            tableFields: [
                {key: 'usuario',        label: 'usuario',        sortable: false },
                {key: 'login',          label: 'login',          sortable: false },
                {key: 'acao',           label: 'acao',           sortable: false },
                {key: 'datahora',       label: 'data',           sortable: false },
            ],
            firstTime: true,
            noData: false,
            isSearching: false,
            meses: [],
            msgs: [],
            pagination: {
                resetPagination: false,
                perPageOptions: [10,25,50,100],
                optionStarted: 0,
                perPage: null,
                totalRows: 0,
                currentPage: 1
            },
            // column: 'cliente',
            // order: 'desc',
            isMobile: false,
            loadedOnce: false,
        };
    },
    created () {
        this.pagination.perPage = this.pagination.perPageOptions[this.pagination.optionStarted];
        this.service = new AuditoriaService(this.$http, this.$router);
        this.colaboradorService = new ColaboradorService(this.$http, this.$router);
        let body = document.getElementsByTagName("body")[0];
        this.permissao = this.hasPermissionAccess("admin", "colaborador", "usuario-auditorias-acesso");
        if ( !this.permissao.read){
            this.$router.push({
                name: 'acesso-nao-permitido',
                params: { tela: 'auditorias-acessos' }
            });
        } else {
            this.loadUsuarios('');        
        }
        body.onresize = this.debounce(this.resize, 150);
    },
    mounted(){
        this.resize();
    },
    beforeDestroy(){
        document.body.onresize = null;
    },
    methods: {
        updatePagination(value){
            this.pagination.resetPagination = false;
            this.pagination.perPage = value.perPage;
            this.pagination.currentPage = value.currentPage;
            this.getDados(value.currentPage);
        },
        getDados ( currentPage = 1) {
            if(currentPage==1&&this.pagination.currentPage!=1)this.pagination.resetPagination=true;
            if ( this.obligatoryFilters() ) {
                this.isSearching = true;
                this.pagination.totalRows = 0;
                if (this.firstTime) {
                    this.firstTime = false;
                }      
                this.service.findAllAuditLogin( this.getFilter( currentPage ) )
                    .then(this.mapData)
                    .catch(e => {
                        console.error('Erro ao trazer dados das auditorias.', e);
                        this.showMessage('error', 'msg-erro-relatorio');
                        this.noData = true;
                    })
                    .finally(() => {
                        this.isSearching = false;
                    });
            }
        },
        getFilter(currentPage){            
            let filtros = {};
            filtros.datainicial = this.$moment(this.periodo.ini).format('DD/MM/YYYY');
            filtros.datafinal = this.$moment(this.periodo.fim).format('DD/MM/YYYY');
            if (this.usuarioSelected){
                filtros.idusuarioerp = this.usuarioSelected.id;
            }
            if (this.acaoSelected){
                filtros.origem = this.acaoSelected.id;
            } else {
                //é passado -1 para que o server saiba que precisa enviar os logins de todas as ações possiveis.
                filtros.origem = -1;
            }
            filtros.pageNumber = currentPage - 1;
            filtros.limit = this.pagination.perPage;
            return filtros;
        },
        mapData (r) {
            this.pagination.totalRows = r.totalElements;
            this.tableData = r.content;
            this.tableData.forEach( log => {
                switch(log.loginok){
                    case 0:
                        log.acao = "LOGIN_FALHA";
                        break;
                    case 1:
                        log.acao = "LOGIN_SUCESSO";
                        break;
                    case 2:
                        log.acao = "LOGOUT";
                        break;
                    default:
                        break;
                }
            });
            this.noData = this.pagination.totalRows <= 0;    
            this.tableKey++;
            this.resize();
        },
        loadUsuarios (q) {
            this.usuarioLoading = true;
            this.colaboradorService.findListAssociated(q)
                .then(r => {
                    if (r.status != 200) {
                        console.error(`Erro com status ${r.status} ao realizar pesquisa por usuários. Termo: [${q}].`);
                        this.usuarioOptions = [];
                    } else {
                        if (r.length > 1){
                            this.tableFields[1].visible = true;
                        }
                        this.usuarioOptions = r.content.map(v => {
                            return {
                                id: v.idusuarioerp,
                                label: v.nome.toLocaleUpperCase()
                            }
                        });
                    }
                })
                .catch(e => {
                    console.error(`Erro ao realizar pesquisa por vendedores. Termo: [${q}].`, e);
                    this.usuarioOptions = [];
                })
                .finally(() => {
                    this.usuarioLoading = false;
                    if (this.usuarioOptions.length > 1){
                        this.tableFields[1].visible = true;
                    }
                });
        },
        validateDatas() {
            let dr = /\d\d\/\d\d\/\d\d\d\d/; // regex para dd/dd/dddd
            let valid = true;
            let iniMoment = null;    
            let fimMoment = null;

            iniMoment = this.$moment(this.periodo.ini);
            /* Validando período de início */
            if (!dr.test( iniMoment.format('L') )) {
                console.error(`Validação falhou no período inicial, data inválida: [${this.periodo.ini}]`);
                this.showMessage('error', 'msg-erro-periodo-inicio');
                valid = false;
            }

            if ( !iniMoment.isValid() ) {
                console.error(`Validação falhou no período inicial, data inválida: [${this.periodo.ini}]`);
                this.showMessage('error', 'msg-erro-periodo-inicio');
                valid = false;
            }

            /* Validando período de fim */
            if ( this.periodo.fim != null && this.periodo.fim != '' ){
                fimMoment = this.$moment(this.periodo.fim);

                if (!dr.test( fimMoment.format('L') )) {
                    console.error(`Validação falhou no período final, data inválida: [${this.periodo.fim}]`);
                    this.showMessage('error', 'msg-erro-periodo-final');
                    valid = false;
                }

                if ( !fimMoment.isValid() ) {                
                    console.error(`Validação falhou no período final, data inválida: [${this.periodo.fim}]`);
                    this.showMessage('error', 'msg-erro-periodo-final');
                    valid = false;
                }
            }

            // Se as duas datas forem válidas
            if (iniMoment !== null && fimMoment !== null && valid) {
                // Se a data de início for acima da data de fim
                if ( fimMoment.isBefore( iniMoment ) ) {
                    console.error(`Validação falhou no período, data inicial maior que a final: [${this.periodo.ini} > ${this.periodo.fim}]`);
                    this.showMessage('error', 'msg-erro-periodo-inicial-final');
                    valid = false;
                }
            }

            return valid;
        },
        obligatoryFilters(){
            let valid = true;
            valid = this.validateDatas();
            if ( this.usuarioSelected == null ){
                console.error(`Filtro(s) obrigatório(s) não foram selecionado(s).`)
                this.showMessage('error', 'msg-campos-obrigatorios');
                valid = false;
            if(this.usuarioSelected==null)this.$refs.usuarioFilterInput.focusedOut=true
            }
            return valid;
        },

        //     return valid;
        // },
        // limparFiltros () {
        //     this.vendedorOptionSelected = null;
        //     this.clienteOptionSelected = [];
        //     this.fotos = { label: 'todos', id: 0 };
        //     this.motivosNaoVendasSelected = [];
        //     this.empresaOptionSelected = [];
        //     this.periodo = { 
        //         ini: this.$moment().subtract(1, 'M').toDate(),
        //         fim: this.$moment().toDate(),
        //     };
        // },
        showMessage (type, message) {
            this.msgs.push(
                new Message(type, message, true)
            );
        },
        resize () {
            let neededWidth = (document.querySelector('.page').offsetWidth * 0.35) + ((this.meses.length + 1) * 150);
            
            this.isMobile = window.innerWidth <= 768;

            if (this.tableData.length > 0) {
                setTimeout(() => {
                    if (neededWidth > (document.querySelector('.page').offsetWidth + 200)) {
                        document.querySelector('.table-results').setAttribute("style",`width: ${neededWidth}px`);
                    } else {
                        document.querySelector('.table-results').setAttribute("style",'');
                    }
                }, 16);
            }
        },
        redirect(time) {
            setTimeout(() => {
                this.$router.push({ name: "ven-cockpit" });
            }, time * 1000);
        },
        // sortTable(field, order) {
        //     this.column = field;
        //     this.order = order;
        //     this.getDados();
        // },
        clickEvt(e) {
            let path = e.path || e.composedPath();

            if (this.showSecondaryFilters && !path.includes(this.$refs.secondaryFilter) && !path.includes(this.$refs.btnFilter) ) {
                this.showSecondaryFilters = false;
            }
        },
        showAuditoriaDetalheModal(id){
            this.isShowingAuditoriaDetalhe = !this.isShowingAuditoriaDetalhe;
            this.idAuditoriaDetalhe = id;
        },
        handleDateChange(nova_data, campo) {

            let today = this.$moment();
            let limInferior = this.$moment().subtract(50,'Y');
            let inserido = this.$moment(nova_data,'DD-MM-YYYY');

            switch (campo) {
                case 'inicio':
                    if(inserido.isBefore(limInferior)){
                        // se selecionar ou digitar um dia anterior a 50 anos atrás
                        this.$nextTick( _ => { 
                            this.$set(this.periodo, 'ini', limInferior.toDate());
                        });
                    }else if(inserido.isAfter(today)){
                        // se selecionar ou digitar uma data posterior a hoje
                        this.$nextTick( _ => { 
                            this.$set(this.periodo, 'ini', today.toDate()); 
                        });
                    }else{
                        // se selecionar ou digitar um dia entre hoje e 50 anos atrás
                        this.$nextTick( _ => { 
                            this.$set(this.periodo, 'ini', nova_data);
                        });
                    }
                    break;
                case 'fim':
                    if(inserido.isBefore(this.$moment(this.periodo.ini))){
                        // se selecionar ou digitar um dia antes do filtro de inicio
                        this.$nextTick( _ => { 
                            this.$set(this.periodo, 'fim', this.$moment(this.periodo.ini).toDate());
                        });
                    }else if(inserido.isAfter(today)){
                        // se selecionar ou digitar um dia depois de hoje
                        this.$nextTick( _ => { 
                            this.$set(this.periodo, 'fim', today.toDate());
                        });
                    }else{
                        // se selecionar ou digitar um dia entre o filtro de inicio e hoje
                        this.$nextTick( _ => { 
                            this.$set(this.periodo, 'fim', nova_data);
                        });
                    }
                    break;
            }
        },
    },
};
</script>

<style lang="scss" scoped>
$padding: 5px;

#main {
    padding: 0 15px 15px 20px;
    height: auto;
    font-size: 13px;
}

.pv-6{
    padding-top: 6px;
    padding-bottom: 6px;
}
.pt-19{
    padding-top: 19px !important;
}

.is-top-mobile{
    padding-bottom: 6px;
}
.is-bottom-mobile{
    padding-top: 6px;
}

.location-icon{
    color: $primary-color;
    &:hover{
        color: $primary-color-hover;
    }
}

.results {
    padding: 5px;
    overflow-x: auto;
    border: 1px solid #D0CFCF;
    border-radius: 5px;
    background-color: #fff;
}

.table-data {
    display: flex;
    align-items: center;
    
    .atributos {    
        .atributo {
            padding: 8px 0px;
        }
    }
}

.btn{
    width: 100%;
    height: 40px;
    color: $sovis-white;
    &.search{
        background-color: $green-alert;
        &:hover{
            background-color: $green-alert-hover;
        }
    }
    &:hover{
        color: $sovis-white;
    }
    &:disabled{
        opacity: 0.6;
    }
}
</style>